import React, { useState } from "react";
import { api, formatApiError } from "@/lib/apiClient";
import { SITE, waLink } from "@/data/site";
import { toast } from "sonner";
import { Send } from "lucide-react";

// Reusable inquiry form -> stores lead + opens WhatsApp
export function LeadForm({ source = "contact", itinerarySlug = "", extraFields = null, buttonLabel = "Send enquiry", waPrefix }) {
  const [form, setForm] = useState({ name: "", phone: "", email: "", message: "", ...(extraFields ? extraFields.initial : {}) });
  const [busy, setBusy] = useState(false);

  const upd = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || (!form.phone && !form.email)) {
      toast.error("Please add your name and a phone or email.");
      return;
    }
    setBusy(true);
    const payload = {};
    if (extraFields) extraFields.keys.forEach((k) => { payload[k] = form[k]; });
    try {
      await api.post("/leads", {
        name: form.name, phone: form.phone, email: form.email, message: form.message,
        source, itinerary_slug: itinerarySlug, payload,
      });
      toast.success("Thank you — our team will reach out shortly.");
      const waText = `${waPrefix || "Hi Vacanza Go, I'd like to enquire."}\n\nName: ${form.name}${form.phone ? `\nPhone: ${form.phone}` : ""}${form.message ? `\nDetails: ${form.message}` : ""}`;
      window.open(waLink(waText), "_blank");
      setForm({ name: "", phone: "", email: "", message: "", ...(extraFields ? extraFields.initial : {}) });
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail));
    } finally {
      setBusy(false);
    }
  };

  const input = "w-full rounded-md border border-[#553204]/15 bg-white px-4 py-3 text-sm outline-none focus:border-[#F49E1A] transition-colors";

  return (
    <form onSubmit={submit} className="space-y-4" data-testid={`lead-form-${source}`}>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <input data-testid="lead-name" className={input} placeholder="Your name *" value={form.name} onChange={upd("name")} />
        <input data-testid="lead-phone" className={input} placeholder="Phone / WhatsApp" value={form.phone} onChange={upd("phone")} />
      </div>
      <input data-testid="lead-email" className={input} placeholder="Email" value={form.email} onChange={upd("email")} />
      {extraFields && extraFields.render(form, upd, input)}
      <textarea data-testid="lead-message" className={input} rows={4} placeholder="Tell us about your plans — dates, group size, preferences…" value={form.message} onChange={upd("message")} />
      <button disabled={busy} data-testid="lead-submit" className="inline-flex items-center gap-2 rounded-full btn-orange px-7 py-3 text-sm disabled:opacity-60">
        <Send size={16} /> {busy ? "Sending…" : buttonLabel}
      </button>
    </form>
  );
}
